// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import jQuery from 'jquery'

window.$ = jQuery
window.jQuery = jQuery
